import { createActions, createReducer } from "reduxsauce";

//Action types e Creators
export const { Types, Creators } = createActions({
    cdList: ['cds'],
    cdClean: ['']
});

//Reducer Handlers
const INITIAL_STATE = []

const cdList = (state = INITIAL_STATE, action) =>
    action.payload

const clean = (state = INITIAL_STATE, action) =>
    INITIAL_STATE

//Criando Reducer
export default createReducer(INITIAL_STATE, {
    [Types.CD_LIST]: cdList,
    [Types.CD_CLEAN]: clean
});
